import { Suspense } from 'react';
import {
  ClientLoaderFunction,
  href,
  matchPath,
  Outlet,
  redirect,
} from 'react-router';
import { ErrorPage } from '@/components/error-page/error-page.tsx';
import { Page, PageContent } from '@/components/layout/page.tsx';
import { PageHeaderSearch } from '@/components/page-header/page-header-search.tsx';
import { headerTitle } from '@/components/page-header/page-header.css.ts';
import { PageHeader } from '@/components/page-header/page-header.tsx';
import { useRedesign } from '@/feature-flags/redesign/use-redesign.ts';
import { paths } from '@/routes-utils/paths.ts';

export const ErrorBoundary = ErrorPage;

const redirectIfIndex = ({ request }: { request: Request }) => {
  const isIndex = matchPath(href('/p/home'), new URL(request.url).pathname);

  if (!isIndex) return null;

  return redirect(paths.explore);
};

export const loader = redirectIfIndex;

export const clientLoader: ClientLoaderFunction = redirectIfIndex;

export default function Home() {
  const redesign = useRedesign();

  if (redesign) {
    return <Outlet />;
  }

  return (
    <Page>
      <PageHeader noBackButton>
        <span className={headerTitle}>Explore</span>
        <PageHeaderSearch />
      </PageHeader>
      <PageContent>
        <Suspense fallback={null}>
          <Outlet />
        </Suspense>
      </PageContent>
    </Page>
  );
}
